import { ReactNode } from "react";
import { SvgIcon } from "@mui/material";
import styles from "./StepCard.module.css";
import CheckCircle from "../images/check-circle.svg?react";

function SetupCardContent({
	title,
	rightContent,
	children,
}: {
	title: ReactNode;
	rightContent?: ReactNode;
	children: ReactNode;
}) {
	return (
		<>
			<div className={styles.cardContent}>
				<div className={styles.textArea}>
					<div className={styles.cardTitle}>{title}</div>
					{children}
				</div>
				{rightContent}
			</div>
		</>
	);
}

export default function StepCard({
	title,
	rightContent,
	children,
	complete = false,
	mobileStyling = false,
}: {
	title: ReactNode;
	rightContent?: ReactNode;
	children: ReactNode;
	complete?: boolean;
	mobileStyling?: boolean;
}) {
	return (
		<li
			className={`${styles.step} ${complete ? styles.complete : ""} ${mobileStyling ? styles.mobileStep : ""}`}
			style={mobileStyling ? { padding: "16px", borderRadius: "0px", border: "0px" } : {}}
		>
			{complete && (
				<SvgIcon className={`${styles.checkIcon} ${mobileStyling ? styles.mobileCheckIcon : ""}`}>
					<CheckCircle />
				</SvgIcon>
			)}
			<SetupCardContent title={title} rightContent={rightContent}>
				{children}
			</SetupCardContent>
		</li>
	);
}

export function SetupStepList({ children }: { children: ReactNode }) {
	return <ol className={styles.stepList}>{children}</ol>;
}
